export default [
    {
        path: '/users/permissions/create',
        name: 'Permissions_Create',
        component: () => import('@/views/user/permission/create.vue'),
        meta: {
            authRequired: true,
            permission: 'Developer'
        }
    },
    {
        path :'/users/permissions/list',
        name: 'Permissions_List',
        component: () => import('@/views/user/permission/list.vue'),
        meta:{
            authRequired: true,
            permission: 'Developer'
        }
    },
    {
        path: '/users/permissions/edit/:id',
        name: 'Permissions_Update',
        component: () => import('@/views/user/permission/edit.vue'),
        meta:{
            authRequired: true,
            permission: 'Developer'
        }
    },
    {
        path: '/users/groups/create',
        name: 'UserGroups_Create',
        component: () => import('@/views/user/group/create.vue'),
        meta: {
            authRequired: true,
            permission: 'roles.store'
        }
    },
    {
        path: '/users/groups/list',
        name: 'UserGroups_List',
        component: () => import('@/views/user/group/list.vue'),
        meta: {
            authRequired: true,
            permission: 'roles.index'
        }
    },
    {
        path: '/users/groups/edit/:id',
        name: 'UserGroups_Update',
        component: () => import('@/views/user/group/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'roles.update'
        }
    },
    {
        path: '/users/create',
        name: 'Users_Create',
        component: () => import('@/views/user/create.vue'),
        meta: {
            authRequired: true,
            permission: 'Administrator'
        }
    },
    {
        path: '/users/list',
        name: 'Users_List',
        component: () => import('@/views/user/list.vue'),
        meta: {
            authRequired: true,
            permission: 'Administrator'
        }
    },
    {
        path: '/users/edit/:id',
        name: 'Users_Update',
        component: () => import('@/views/user/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'Administrator'
        }
    },
    {
        path: '/users/change-pass',
        name: 'Force_Change_Pass',
        component: () => import('@/views/pages/authentication/ResetPassword.vue'),
        meta: {
            layout: 'full',
            authRequired: true
        }
    },

    {
        path: '/user/organization/create',
        name: 'Organization_Unit_Create',
        component: () => import('@/views/user/organization/create.vue'),
        meta: {
            authRequired: true,
            permission: 'organizations.store'
        }
    },
    {
        path: '/user/organization/list',
        name: 'Organization_Unit_List',
        component: () => import('@/views/user/organization/list.vue'),
        meta: {
            authRequired: true,
            permission: 'organizations.index'
        }
    },
    {
        path: '/user/organization/edit/:id',
        name: 'Organization_Unit_Update',
        component: () => import('@/views/user/organization/edit.vue'),
        meta: {
            authRequired: true,
            permission: 'organizations.update',
            navActiveLink:'Organization_Unit_List'
        }
    },
    {
        path: '/users/login-logs',
        name: 'Users_login_logs',
        component: () => import('@/views/user/logs.vue'),
        meta: {
            authRequired: true,
        }
    },

]
